<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">
                    <el-form-item label="父级分类:">
                        <el-select v-model="table.where.parent_id" filterable placeholder="请选择">
                            <el-option v-for="item in store_goods_cat_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="店铺:">
                        <el-select v-model="table.where.shop_id" filterable placeholder="请选择">
                            <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="分类名称:">
                        <el-input v-model="table.where.name" placeholder="请输入分类名称" clearable />
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-select v-model="table.where.status" filterable placeholder="请选择">
                            <el-option label="显示" value="1"></el-option>
                            <el-option label=" 不显示" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="排序:">
                        <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:storegoodscat:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->
            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-restore"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoodscat:add')">添加
                </el-button>
                <!-- <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoodscat:dall')">批量删除
                </el-button> -->
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />
                    <!-- <el-table-column prop="parent_id" label="父级分类" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.parent_id_info" :key="index">{{item.name}}</el-tag>
                        </template>
                    </el-table-column> -->

                    <el-table-column prop="name" label="分类名称" sortable="custom" show-overflow-tooltip min-width="120" />
                    <el-table-column prop="shop_id" label="店铺" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.shop_id_info" :key="index">{{item.name}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="thumbnail_image" label="分类图" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-image style="width: 50px; height: 50px" :src="row.thumbnail_image"
                                :preview-src-list="[row.thumbnail_image]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="tips" label="简介" sortable="custom" show-overflow-tooltip min-width="120" /> -->
                    <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.status" @change="editStatus(row,'status')" :active-value="1"
                                :inactive-value="2" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="index_status" label="首页显示状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.index_status" @change="editStatus(row,'index_status')" :active-value="1"
                                :inactive-value="2" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip min-width="120" />
                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoodscat:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此商品分类吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:storegoodscat:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改商品分类':'添加商品分类'" :visible.sync="showEdit" width="800px"
            :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                <el-form-item label="父级分类:" prop="parent_id">
                    <el-cascader v-model="editForm.parent_id" :options="store_goods_cat_list"
                        :props="{ checkStrictly: true,value:'id',label:'name' }" clearable></el-cascader>
                </el-form-item>
                <el-form-item label="分类名称:" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入分类名称" clearable />
                </el-form-item>
                <el-form-item label="店铺:" prop="shop_id">
                    <el-select v-model="editForm.shop_id" filterable placeholder="请选择">
                        <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="简介:" prop="tips">
                    <el-input v-model="editForm.tips" placeholder="请输入简介" clearable />
                </el-form-item> -->
                <el-form-item label="分类图:" prop="thumbnail_image">
                    <ele-uploadimage :limit="1" v-model="editForm.thumbnail_image"></ele-uploadimage>
                </el-form-item>

                <el-form-item label="状态:" prop="status">
                    <el-switch v-model="editForm.status" active-text="是" inactive-text="否" :active-value="1"
                        :inactive-value="0" />
                </el-form-item>

                 <el-form-item label="首页显示:" prop="index_status">
                    <el-switch v-model="editForm.index_status" active-text="是" inactive-text="否" :active-value="1"
                        :inactive-value="2" />
                </el-form-item>
                <el-form-item label="排序:" prop="sort">
                    <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0"
                        class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import EleUploadimage from '@/components/EleUploadimage'

    export default {
        name: "SysstoreGoodsCat",
        components: {
            EleUploadimage,
        },
        data() {
            return {
                table: {
                    url: '/store/storeGoodsCat/index',
                    where: {
                        "thumbnail_image": []
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "thumbnail_image": []
                }, // 表单数据
                editFormTemp: {
                    "thumbnail_image": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                store_goods_cat_list: [],
                store_shop_management_list:[],
                editRules: { // 表单验证规则
                    parent_id: [{
                        required: true,
                        message: '请选择父级分类ID,顶级分类则为0',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: '请输入分类名称',
                        trigger: 'blur'
                    }],
                    thumbnail_image: [{
                        required: true,
                        message: '请上传分类图',
                        trigger: 'blur'
                    }],
                    create_time: [{
                        required: true,
                        message: '请选择创建时间',
                        trigger: 'blur'
                    }],
                    path: [{
                        required: true,
                        message: '请输入分类树',
                        trigger: 'blur'
                    }],
                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {
            this.StoreShopManagementAllList();
            this.storeGoodsCatAllList();
        },
        methods: {
            add() {
                this.$http.post('/store/storeGoodsCat/allList', ).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        this.store_goods_cat_list = res.data.data;
                        let temp_data = {
                            id:0, 
                            name:'无上级', 
                        }
                        this.store_goods_cat_list.unshift(temp_data);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/store/storeGoodsCat/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        if (Array.isArray(this.editForm.parent_id)) {
                            this.editForm.parent_id = this.editForm.parent_id[this.editForm.parent_id.length -
                                1];
                        }
                        this.$http.post('/store/storeGoodsCat/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的商品分类吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/store/storeGoodsCat/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/store/storeGoodsCat/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids = this.choose.map(d => d.id)
                if (ids.length == 0) {
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {
                        id: ids
                    })
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            //查询其他信息
            storeGoodsCatAllList() {
                // {parent_id:0}
                this.$http.post('/store/storeGoodsCat/allList', ).then(res => {
                    if (res.data.code === 0) {
                        this.store_goods_cat_list = res.data.data;
                        let temp_data = {
                            id:0, 
                            name:'无上级', 
                        }
                        this.store_goods_cat_list.unshift(temp_data);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            StoreShopManagementAllList() {
                this.$http.post('/store/StoreShopManagement/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.store_shop_management_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },

            /**
     * 更改状态

     */
            editStatus(row, name) {
                const loading = this.$loading({
                    lock: true
                });
                let data = {
                    id: row.id,
                    name: name,
                    value: row[name],
                }
                this.$http.post("/store/storeGoodsCat/status", data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row[name] = !row[name] ? 1 : 0;
                        this.$message.error(res.data.msg);

                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>